import { Table } from 'semantic-ui-react';
import { LinkedSpeakingSessionDto } from 'api/planning';
import { SpeakingSessionRow } from './SpeakingSessionRow';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { LinkSessionButton } from './LinkSessionButton';

type Props = {
  linkedSpeakingSessions: LinkedSpeakingSessionDto[];
  canUnlinkSpeakingSession: boolean;
  openUnlinkModal: (speakingSessionId: number) => void;
};

export const SpeakingSessionsTable = ({
  linkedSpeakingSessions,
  canUnlinkSpeakingSession,
  openUnlinkModal,
}: Props) => {
  return (
    <>
      <S.Actions>
        <LinkSessionButton />
      </S.Actions>

      <Table celled size="small">
        <S.TableHeader>
          <Table.Row>
            <S.TableHeaderCell size="120px">Speaking date</S.TableHeaderCell>
            <Table.HeaderCell>Venue</Table.HeaderCell>
            <Table.HeaderCell>Planned slots</Table.HeaderCell>
            <Table.HeaderCell>Available slots</Table.HeaderCell>
            <Table.HeaderCell>Registrations</Table.HeaderCell>
            <S.TableHeaderCell size="180px"></S.TableHeaderCell>
          </Table.Row>
        </S.TableHeader>
        <Table.Body>
          {linkedSpeakingSessions.map((x) => (
            <SpeakingSessionRow
              linkedSpeakingSession={x}
              key={x.id}
              canUnlinkSpeakingSession={canUnlinkSpeakingSession}
              openUnlinkModal={openUnlinkModal}
            />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

const S = {
  TableHeader: styled(Table.Header)`
    .ui.table > thead& {
      box-shadow: 0 5px 5px #0001;
    }
  `,
  TableHeaderCell: styled(Table.HeaderCell, {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'size',
  })<{ size: string }>`
    th& {
      width: ${(props) => props.size};
    }
  `,
  Actions: styled.div`
    display: flex;
    justify-content: end;
  `,
};
